module.exports = __webpack_public_path__ + "media/D2.0fe14f28.mp3";